import BrandLogo from "../components/BrandLogo";

export function AdminLoadingState({ themeMode }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        background: "var(--bg-app)",
        color: "var(--text-primary)",
        fontFamily: "var(--font-sans)",
        gap: 16,
      }}
    >
      <div style={{ animation: "pulse 1.8s infinite ease-in-out" }}>
        <BrandLogo variant="icon" height={64} isDark={themeMode === "dark"} />
      </div>
      <div style={{ fontSize: "var(--text-body-sm)", fontWeight: 500, color: "var(--text-muted)" }}>
        Carregando Painel Administrativo...
      </div>
    </div>
  );
}

export function ContentLoadingState() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        color: "var(--text-muted)",
        fontSize: "var(--text-body-sm)",
        fontWeight: 500,
      }}
    >
      Carregando conteúdo...
    </div>
  );
}
